/**
 * summarization.ts
 * Copyright (c) 2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

 /**
  * The names for the summarizations used by the server.
  */
export type SummarizationLabel =
    "none" | "count" | "sum" | "average" | "inline";

/**
 * The {@link SummarizationType} interface holds client-local information about
 * the behavior of each summarization method.
 */
export interface SummarizationType
{
    /**
     * The protocol/server name for the summarization.
     */
    name : SummarizationLabel;

    /**
     * The human-readable name for the summarization. This may be used to
     * construct default column headers.
     */
    displayName : string;

    /**
     * Whether it should only apply to variables with numeric types.
     */
    numericalOnly : boolean;
}

const COUNT : SummarizationType =
    {name: "count", displayName: "count", numericalOnly: false};
const SUM : SummarizationType =
    {name: "sum", displayName: "sum", numericalOnly: true};
const AVERAGE : SummarizationType =
    {name: "average", displayName: "average", numericalOnly: true};
const INLINE : SummarizationType =
    {name: "inline", displayName: "inline list", numericalOnly: false};

/**
 * The types themselves, other than "none".
 */
export const NonDefaultSummarizations : SummarizationType[] = [
    COUNT,
    SUM,
    AVERAGE,
    INLINE
];

export const DefaultSummarization : SummarizationType = {
    name: "none",
    displayName: "values",
    numericalOnly: false
};

export const SummarizationByName : Map<SummarizationLabel, SummarizationType> =
    new Map([
        ["count", COUNT],
        ["sum", SUM],
        ["average", AVERAGE],
        ["inline", INLINE],
        ["none", DefaultSummarization]
    ] as Array<[SummarizationLabel, SummarizationType]>);



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/summarization.ts